import { Skeleton } from '@/components/ui/skeleton'

export const GuideHeaderSkeleton = () => {
  return (
    <header className="sticky top-0 z-50 flex h-14 w-full shrink-0 items-center border-b bg-background">
      <div className="flex w-full items-center gap-1 px-4 lg:gap-2 lg:px-6">
        {/* Nav trigger */}
        <Skeleton className="size-8 rounded-md" />

        {/* Navigation */}
        <div className="flex flex-1 justify-center">
          <div className="flex items-center gap-2">
            <Skeleton className="h-9 w-24 rounded-md" />
            <Skeleton className="h-9 w-28 rounded-md" />
            <Skeleton className="h-9 w-28 rounded-md" />
            <Skeleton className="h-9 w-28 rounded-md" />
            <Skeleton className="h-9 w-20 rounded-md" />
            <Skeleton className="h-9 w-24 rounded-md" />
            <Skeleton className="h-9 w-20 rounded-md" />
          </div>
        </div>

        {/* Search + Logo */}
        <div className="flex min-w-[120px] items-center justify-end gap-3">
          <Skeleton className="h-9 w-40 rounded-md" />
          <Skeleton className="h-8 w-36 rounded-md" />
        </div>
      </div>
    </header>
  )
}
